const removeNullKeys = (obj) => {
  const newObj = { ...obj }
  Object.keys(newObj).forEach((k) => newObj[k] == null && delete newObj[k])
  return newObj
}

export default removeNullKeys
